import axios from "axios";

const elasticInstace = axios.create({
  baseURL: `https://es-product-search.devops.multpex.com.br`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json;",
    "x-api-key": "weijefioejv03iehjvwiov0w3ijv",
  },
});

const actions = {
  listarCompras: async (
    context,
    { vendor_id, compra_sugerida = 0, per_page, page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/mrp`, {
      params: {
        per_page,
        vendor_id,
        page,
        compra_sugerida,
        search,
      },
    });

    return response;
  },

  listarProdutosAcciona: async (context, { descricao = "teste" }) => {
    const response = elasticInstace.get("/search", {
      params: {
        descricao,
      },
    });

    return response;
  },

  listarEstoqueSelecionado: async (
    context,
    { cod_produto, com_saldo = 1, per_page = 30, page, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get("/products/estoque-consolidado", {
      params: {
        page,
        cod_produto,
        com_saldo,
        per_page,
        vendor_id,
      },
    });

    return response;
  },

  setScNumero: async (context, { uuid, cod_integracao, observacao }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/necessidade-compra/${uuid}`, {
      cod_integracao,
      observacao,
      uuid,
    });

    return response;
  },

  setEditarCabecalho: async (context, payload) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${payload.uuid}/valida-responsavel`,
      {
        numero: payload.numero,
        usuario_nome: payload.usuario_nome,
        tag: payload.tag,
        solicitante_nome: payload.solicitante_nome,
        cost_center_code: payload.cost_center_code,
        cost_center_name: payload.cost_center_name,
        created_at: payload.created_at,
      }
    );

    return response;
  },

  editarProdutosNecessidadeNome: async (
    context,
    { uuid, uuidItem, matricula_responsavel }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/valida-responsavel`,
      {
        matricula_responsavel,
      }
    );

    return response;
  },

  editarProdutosNecessidadeCost: async (
    context,
    { uuid, uuidItem, cost_center_code }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/valida-responsavel`,
      {
        cost_center_code,
      }
    );

    return response;
  },

  editarProdutosNecessidadeCode: async (
    context,
    { uuid, uuidItem, code }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/valida-responsavel`,
      {
        code,
      }
    );

    return response;
  },

  editarQuantidadeItemNecessidade: async (
    context,
    { uuid, uuidItem, quantidade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/valida-responsavel`,
      {
        quantidade: quantidade.toString(),
        need_id: uuid,
        uuid: uuidItem,
      }
    );

    return response;
  },

  removerResponsavelProduto: async (context, { uuid, uuidItem }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/necessidade-compra/${uuid}/item/${uuidItem}/remover-responsavel`
    );

    return response;
  },

  getHistoricoNecessidade: async (context, { necessidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/necessidade-compra/historico/${necessidadeId}`
    );

    return response.data;
  },

  getHistoricoItemNecessidade: async (context, { necessidadeId, itemId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/necessidade-compra/historico/${necessidadeId}/item/${itemId}`
    );

    return response.data;
  },

  acompanhar: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    try {
      const necessidadeResponse = await api.get(`/necessidade-compra/${uuid}`);

      const itensResponse = await api.get(`/necessidade-compra/${uuid}/itens`, {
        params: {
          per_page: 1000,
        },
      });

      return {
        data: {
          data: [
            {
              ...necessidadeResponse.data.data,
              itens: itensResponse.data.data,
            },
          ],
        },
      };
    } catch (error) {
      console.error("Erro ao buscar necessidade:", error);
      throw error;
    }
  },

  getSemReferencia: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/necessidade-compra/itens-fora-catalogo`, {
      params: {
        data_inicial: "01/01/2001",
        per_page: 1000,
        associado: 0,
        comprado: 2,
        uuid,
      },
    });

    return response;
  },

  atualizar: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/recalcular-mrp`);

    return response;
  },
};

export const comprasSolicitante = {
  namespaced: true,
  actions,
};
